class Person {
	constructor() {
		var toggler = document.getElementsByClassName("modal-toggle");
		var headerToggler = document.getElementsByClassName("header");
		for (var i = 0, len = toggler.length; i < len; i++) {
			toggler[i].addEventListener('click', (e) => {
				var el = e.currentTarget.parentElement.nextElementSibling;
				e.preventDefault();
				if(!el.classList.contains('is-visible')){
					el.classList.add('is-visible');
					headerToggler[0].classList.add('header--disable-sub-menu');
}
			});
		}

		const close = Array.from(document.getElementsByClassName('person__modal--close'));
		const modalOverlay = Array.from(document.getElementsByClassName('person__modal--overlay'));
		const modalWrap = Array.from(document.getElementsByClassName('person__modal--wrap'));
		const handleClick = (e) => {
		//   e.preventDefault();
		var el = e.currentTarget.parentElement.parentElement.parentElement;
			e.preventDefault();
			if(el.classList.contains('is-visible'))
				el.classList.remove('is-visible');
					headerToggler[0].classList.remove('header--disable-sub-menu');
		}
		const closeOverlay = (e) =>  {

			var el = e.currentTarget.parentElement;
		e.preventDefault();

			if(el.classList.contains('is-visible'))
				el.classList.remove('is-visible');
					headerToggler[0].classList.remove('header--disable-sub-menu');
		}
		close.forEach(node => {
			node.addEventListener('click', handleClick)
		});
		modalOverlay.forEach(node => {
			node.addEventListener('click', closeOverlay)
		});
		modalWrap.forEach(node => {
			node.addEventListener('click', function (event) {
			event.stopPropagation()
			})
		});
	}

}

class Persons {
	constructor(node, opts = {}) {
		this.node = node;
		this.persons = Array.from(this.node.querySelectorAll('.person')).map(node => new Person(node, opts));
	}
}

Persons.instances = Array.from(document.querySelectorAll('.people')).map(p => new Persons(p));
export default new Person;